import { createFileRoute } from '@tanstack/react-router'
import { adminOrganizationsQueryOptions } from '@/lib/queries/admin'
import { adminBannersQueryOptions } from '@/lib/queries/banners'
import { AdminBannersPage } from '@/features/admin'

export const Route = createFileRoute('/_authenticated/admin/banners')({
  loader: ({ context }) => {
    void context.queryClient.query({
      ...adminBannersQueryOptions(),
      staleTime: 'static',
    })
    void context.queryClient.query({
      ...adminOrganizationsQueryOptions(),
      staleTime: 'static',
    })
  },
  component: AdminBannersPage,
})
